<ng-container *ngIf="sharedDataState$ | async as state">
    <div class="article-container mat-elevation-z8">
        <div class="table-header">
            <mat-form-field subscriptSizing="dynamic">
                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value"
                        (click)="filter.value=''; applyFilter('');">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table matSort [dataSource]="dataSource">

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.article.name.label" | translate }}</th>
                    <td mat-cell *matCellDef="let article">{{ article.name }}</td>
                </ng-container>

                <ng-container matColumnDef="articleNr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.article.articleNr.label" | translate }}</th>
                    <td mat-cell *matCellDef="let article">
                        {{ article.articleNr }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="baseMeasureUnitId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.article.baseMeasureUnit.label" | translate }}</th>
                    <td mat-cell *matCellDef="let article">
                        {{ state.measureUnitLookup[article.baseMeasureUnitId]?.name }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"></th>
                    <td mat-cell *matCellDef="let article">
                        <button mat-icon-button
                                (click)="openRevenueDialog(article)"
                                matTooltip="{{ 'app.page.article.actions.revenue.label' | translate }}">
                            <mat-icon>euro</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="layout.columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: layout.columns;"></tr>

            </table>
            <mat-paginator showFirstLastButtons [pageSizeOptions]="[20, 50]"></mat-paginator>
        </div>
    </div>
</ng-container>
